import { render, staticRenderFns } from "./RecycleIcon.vue?vue&type=template&id=03b11c8b&"
import script from "./RecycleIcon.vue?vue&type=script&lang=js&"
export * from "./RecycleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports